import Grid from '@mui/material/Grid';
import BaseTable from 'components/Tables/BaseTable';
import { alertError } from 'ducks/alerts';
import { actions as flowActions } from 'ducks/flows';
import { actions } from 'ducks/steps';
import cloneDeep from 'lodash/cloneDeep';
import React from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreById, groupBy } from 'selectors/generic';
import columns from 'utils/tables/columns/steps';
import validator from 'utils/tables/validators/steps';
import { currentUser } from 'selectors/currentUser';

// `step.substeps` is gone: the substeps of a step are the steps that name it as
// their master.
const substepsByMasterStep = groupBy('steps', 'master_step_id');

const Component = props => {
  const { masterStepId, user, steps, substepsByMasterStep } = props;
  const { alertError, create, fetch, fetchFlow, remove, update } = props;
  const tableRef = React.useRef(null);

  const subSteps = cloneDeep(substepsByMasterStep[masterStepId] || []);

  return (
    <Grid size={12}>
      <BaseTable
        ref={tableRef}
        title={`SUB-ETAPAS, ETAPA ${steps[masterStepId].name}`}
        columns={columns(user)}
        data={subSteps}
        onRowClick={() => null}
        options={{
          maxBodyHeight: '50vh',
          minBodyHeight: '50vh'
        }}
        editable={{
          onRowAdd: newData => {
            const validation = validator(newData, subSteps);
            if (validation.error) {
              alertError(validation.error);
              return Promise.reject();
            } else {
              return (
                create({
                  ...validation,
                  master_step_id: masterStepId,
                  flow_id: steps[masterStepId].flow_id
                })
                  .then(() => {
                    fetch(masterStepId);
                    return fetchFlow(steps[masterStepId].flow_id);
                  })
              );
            }
          },
          onRowUpdate: (newData, oldData) => {
            const validation = validator(newData, subSteps);
            if (validation.error) {
              alertError(validation.error);
              return Promise.resolve();
              // TODO Instead of rejecting we are resolving, should be rejecting.
              // Have to update library later github issue #2086
            } else {
              return (
                update(newData.id, newData)
                  .then(() => {
                    fetch(masterStepId);
                    return fetchFlow(steps[masterStepId].flow_id);
                  })
              );
            }
          },
          onRowDelete: oldData =>
            remove(oldData.id)
              .then(() => {
                fetch(masterStepId);
                return fetchFlow(steps[masterStepId].flow_id);
              })
        }}
      />
    </Grid>
  );
};

const makeMapStateToProps = () => {
  const steps = getImmutableStoreById('steps');
  const mapStateToProps = (state, props) => ({
    steps: steps(state),
    substepsByMasterStep: substepsByMasterStep(state),
    user: currentUser(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  create: data => dispatch(actions.createPromise(data)),
  remove: id => dispatch(actions.removePromise(id)),
  update: (id, data) => dispatch(actions.updatePromise(id, data)),
  fetch: id => dispatch(actions.fetchOne(id)),
  fetchFlow: id => dispatch(flowActions.fetchOne(id))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
